import entries from './entries';
import update from './update';
import checkFlag from './checkFlag';

export default {
  entries,
  update,
  checkFlag,
};



// WEBPACK FOOTER //
// ./src/app/services/exciseEntry/index.js